<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="8">
        <el-card style="margin-bottom:0px;">
          <!--左侧评分组-->
          <AppraisalGroup @groupClick="groupClick"></AppraisalGroup>
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-card style="margin-bottom:0px;">
          <vxe-grid
            auto-resize
            ref="vxeGrid"
            highlight-hover-row
            :data="tableData"
            :toolbar-config="tableToolbar"
            :columns="tableColumns"
            :height="tableHeight"
            size="small"
            class="bg-white"
            :loading="loading"
            border
            :seq-config="{
              startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
            }"
          >
            <template v-slot:itemStatus="{ row }">
              <el-tag
                size="mini"
                :type="row.itemStatus === 'Y' ? 'light' : 'warning'"
              >
                {{ row.itemStatusName }}
              </el-tag>
            </template>
            <template v-slot:toolbar_form>
              <b-button
                size="sm"
                variant="outline-success"
                @click="fromLoad('add')"
                v-if="allow('A')"
              >
                <b-icon-plus></b-icon-plus>
                {{ $l('tips_add') || '新增' }}
              </b-button>
            </template>
            <template v-slot:empty="{}">
              <div style="text-align: center">
                <img src="/image/static/img/nodata.png" />
                <p class="no-data">
                  {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
                </p>
              </div>
            </template>
            <template v-slot:pager>
              <slot name="pager"></slot>
            </template>
            <template v-slot:opt="{ row }">
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  v-if="allow('D')"
                  :content="$l('INDEX.btn_tips_del') || '删除'"
                  placement="top"
                >
                  <i
                    class="el-icon-delete tool-btn"
                    v-if="row.itemStatus !== 'N'"
                    @click="del(row, 'N')"
                  ></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$l('INDEX.btn_tips_view') || '查看'"
                  placement="top"
                >
                  <i
                    class="el-icon-view tool-btn"
                    @click="fromLoad('detail', row.appraisalItemCode)"
                  ></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$l('INDEX.btn_tips_edit') || '编辑'"
                  v-if="allow('M')"
                  placement="top"
                >
                  <i
                    class="el-icon-edit tool-btn"
                    @click="fromLoad('edit', row.appraisalItemCode)"
                  ></i>
                  "
                </el-tooltip>
              </div>
            </template>
          </vxe-grid>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="70%"
    >
      <page-detail ref="form" @success="saveSuccess"></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">{{
          $l('INDEX.btn_cancel') || '取 消'
        }}</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="formOption.dialogSaveBtnVisible"
          >{{ $l('INDEX.btn_save') || '保 存' }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import AppraisalGroup from '@/views/digital/resourceManagement/scm/appraisalGroup'
export default {
  props: {
    tableData: {
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {
    AppraisalGroup,
    PageDetail: () => import('./components/detail'),
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  data() {
    return {
      tableHeight: 600,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('groupClick'),
        },
      },
      allChecked: false,
      indeterminate: false,
      selected: [],
      tableColumns: tableColumns(this),

      // 表单设置
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      // 点击左侧评分组选中数据
      param: {
        appraisalGroupCode: '',
      },
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 173
    },
    groupClick(params) {
      this.param = params
      this.$emit('groupClick', params)
    },
    // 加载表单
    fromLoad(ref, val = '') {
      if (ref === 'add') {
        if (!this.param.appraisalGroupCode) {
          this.$message.warning(
            this.$l('tips_selectLeftScoringGroup') || '请选择左侧评分组!'
          )
          return
        }
      }
      const opt = {
        add: this.$l('tips_add') || '新增',
        edit: this.$l('tips_edit') || '编辑',
        detail: this.$l('tips_view') || '详情',
      }
      // 设置标题
      this.formOption.title = opt[ref]
      // 控制保存按钮显隐
      if (ref === 'detail') {
        this.formOption.dialogSaveBtnVisible = false
      } else {
        this.formOption.dialogSaveBtnVisible = true
      }
      // 显示表单
      this.formOption.dialogFormVisible = true
      //详情所需参数
      let detailParam = {
        appraisalItemCode: val,
        appraisalGroupCode: this.param.appraisalGroupCode,
      }
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, detailParam)
      }, 0)
    },
    del(item, status) {
      this.$confirm(
        this.$l('INDEX.tips_question_delete') || '是否删除？',
        this.$l('INDEX.tips_question_title') || '提示',
        {
          confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          item.itemStatus = status
          this.$api.scmAppraisalItemUpdateApi(item).then(() => {
            this.$message.success(this.$l('INDEX.tips_delete_ok') || '删除成功')
            this.$emit('reload')
          })
        })
        .catch(() => {})
    },
    save() {
      this.$refs.form.save()
    },
    saveSuccess() {
      this.cancel()
      this.$emit('reload')
    },
    cancel() {
      this.formOption.dialogFormVisible = false
    },
  },
}
</script>
